import Enumerator from './Enumerator';

export const bankAccountTypes = [
  'none',
  'savings_account',
  'transaction_account',
  'cheque_account',
  'other_account'
];

export class BankAccountType extends Enumerator {
  static default() {
    return this.of('none');
  }

  static of(option?: string) {
    let correctOption = option;
    switch (option) {
      case '1':
        correctOption = 'savings_account';
        break;
      case '2':
        correctOption = 'transaction_account';
        break;
      case '3':
        correctOption = 'cheque_account';
        break;
      case '4':
        correctOption = 'other_account';
        break;
      default:
        break;
    }
    return this.enumValueOf(correctOption) || this.default();
  }
}

BankAccountType.initEnum({
  none: {
    get title() {
      return 'Select one';
    }
  },
  savings_account: {
    get title() {
      return 'Savings account';
    }
  },
  transaction_account: {
    get title() {
      return 'Transaction account';
    }
  },
  cheque_account: {
    get title() {
      return 'Cheque account';
    }
  },
  other_account: {
    get title() {
      return 'Other account';
    }
  }
});

export default {
  bankAccountTypes,
  BankAccountType
};
